(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["skindion-product-linking"] && !Shopify.designMode) return;
  try {
    // Política de parámetros al cambiar de producto (lista permitida; todo lo demás se descarta):
  // - Atribución: utm_*, click IDs de anuncios y ref (afiliados/atribución propia).
  // - preview_theme_id: solo si ya venía en la URL (mantiene la vista previa del theme).
  // - Se descartan variant, selling_plan, plan, section_id y cualquier control de carrito/checkout:
  //   pertenecen a OTRO producto y el plan de rosa no sirve para negro.
  window.SkindionLinkingParams = window.SkindionLinkingParams || {
    CLICK_IDS: ['fbclid', 'gclid', 'gbraid', 'wbraid', 'dclid', 'msclkid', 'ttclid', 'epik'],
    OTHER: ['ref', 'preview_theme_id'],
    keep(key) {
      return key.startsWith('utm_') || this.CLICK_IDS.includes(key) || this.OTHER.includes(key);
    },
    buildHref(href, search, origin) {
      const url = new URL(href, origin);
      new URLSearchParams(search).forEach((value, key) => {
        if (this.keep(key) && value !== '' && !url.searchParams.has(key)) url.searchParams.set(key, value);
      });
      return url.pathname + url.search + url.hash;
    },
  };

  if (!customElements.get('product-linking')) {
    customElements.define(
      'product-linking',
      class ProductLinking extends HTMLElement {
        connectedCallback() {
          if (!window.location.search) return;
          this.querySelectorAll('a[data-linking-url]').forEach((link) => {
            link.setAttribute(
              'href',
              window.SkindionLinkingParams.buildHref(link.getAttribute('href'), window.location.search, window.location.origin)
            );
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
